import { getUserId } from '@/utils/auth';
// 初始化时自动从 token 解析 userid
const token = localStorage.getItem('infoToken') || '';
const userId = getUserId(token);

const state = {
  // token: token,
  // userid: localStorage.getItem('role'),
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  // SET_USER_id: (state, userid) => {
  //   state.userid = userid
  // }
};

const actions = {
  // setUserid({ commit }, userid) {
  //    commit('SET_USER_id', userid)
  // }
};

const getters = {
  token: (state) => state.token,
  userid: (state) => state.userid,
};

export default {
  namespaced: true, // 必须开启：避免命名冲突
  state,
  mutations,
  actions,
  getters,
};
